<template>
  <div class="history-slider"  v-if="slideData.gallery.length >= 1">
    <div class="ttl" v-if="hasTitle">
      <h2 class="f-34 bold-italic">{{$fn.tr('გალერეა')}}</h2>
    </div>
       <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide v-for="(slide, index) in _.get(slideData, 'gallery')" :key="index">
       
        <div class="slide-inner">
            <svg @click="showFull(index)"  id="Component_16_1" data-name="Component 16 – 1" xmlns="http://www.w3.org/2000/svg" width="102.773" height="96.643" viewBox="0 0 102.773 96.643">
  <path id="Union_8" data-name="Union 8" d="M17468.027,11526.535a51.949,51.949,0,0,1-18.766-4.686,44,44,0,0,1-15.178-11.623,61.464,61.464,0,0,1-5.719-8.215,65.465,65.465,0,0,1-4.48-9.129,41.674,41.674,0,0,1-2.635-10,33.579,33.579,0,0,1-.3-5.166,34.759,34.759,0,0,1,.5-5.148,37.4,37.4,0,0,1,3.1-9.666,49.023,49.023,0,0,1,2.58-4.725c-.982,1.113-1.934,2.258-2.814,3.473a32.178,32.178,0,0,0-1.738,2.715c-.555.986-1.064,2-1.537,3.033s-.939,2.1-1.391,3.16c-.43,1.016-.842,2.043-1.268,3.064a.716.716,0,0,1-.439.369.69.69,0,0,1-.572-.082.827.827,0,0,1-.342-.9c.459-1.309.869-2.639,1.352-3.936.475-1.277.982-2.553,1.533-3.795a28.949,28.949,0,0,1,1.871-3.537,34.981,34.981,0,0,1,2.309-3.283c.811-1.014,1.654-1.992,2.521-2.943s1.785-1.887,2.732-2.76c1.654-1.51,3.4-2.91,5.164-4.27.555-.613,1.115-1.213,1.688-1.807,1.164-1.193,2.357-2.357,3.621-3.43a46.316,46.316,0,0,1,3.834-2.941,54.157,54.157,0,0,1,8.434-4.648,73.3,73.3,0,0,1,9.186-3.363c1.559-.463,3.131-.869,4.721-1.2a29.027,29.027,0,0,1,4.8-.625,17.013,17.013,0,0,1,3.348.2,51.541,51.541,0,0,1,6.8-.652c.391-.008.785-.014,1.182-.014a40.314,40.314,0,0,1,8.627.9,33.061,33.061,0,0,1,9.127,3.43,31.085,31.085,0,0,1,4.027,2.672,36.312,36.312,0,0,1,3.688,3.3,33.819,33.819,0,0,1,5.8,7.934,45.748,45.748,0,0,1,2.084,4.748c.607,1.605,1.178,3.223,1.674,4.871a60.608,60.608,0,0,1,2.139,10.342,69.409,69.409,0,0,1,.434,10.66,57.754,57.754,0,0,1-4.223,20.352,42.48,42.48,0,0,1-11.455,15.783,47.4,47.4,0,0,1-7.8,5.418,49.445,49.445,0,0,1-8.861,3.807,52.113,52.113,0,0,1-9.6,2.035,54.425,54.425,0,0,1-6.453.393Q17469.678,11526.645,17468.027,11526.535Zm-43.77-64.8.051-.066Zm.078-.109.082-.115Zm22.148-22.254a45.713,45.713,0,0,0-5.6,3.99c-.828.693-1.631,1.424-2.412,2.182q.513-.36,1.031-.705,2.036-1.354,4.145-2.572,4.26-2.479,8.732-4.516a87.5,87.5,0,0,1,18.615-6.51l.545-.109c-.18,0-.365,0-.547.008a27.585,27.585,0,0,0-2.975.268l.025,0a51.571,51.571,0,0,0-7.9,1.926c-1.311.42-2.621.855-3.912,1.342-1.256.473-2.5,1-3.727,1.551l.01,0-.016.006.006,0-.012,0-.057.025.023-.008A59.059,59.059,0,0,0,17446.484,11439.371Zm6.016-3.145.006,0-.039.02Z" transform="translate(-17416.998 -11430.002)" fill="#fff"/>
  <g id="Group_450" data-name="Group 450" transform="translate(1192.539 -3584.591) rotate(25)">
    <path id="Path_1797" data-name="Path 1797" d="M20.471.439c-.943,1.1-1.863,2.225-2.851,3.282C16.385,5.042,16.463,6.726,16.2,8.332a8.093,8.093,0,0,0,2.492,7.284c1.134,1.112,2.972,1.546,4.555,2.124a12.954,12.954,0,0,0,2.735.383c-3.676,1.161-7.287.1-10.821-.549A70.111,70.111,0,0,1,5.125,14.6,18.84,18.84,0,0,1,1.3,12.455C-.2,11.507-.316,11.112.508,9.51A15.951,15.951,0,0,1,12.787.785C15.274.374,17.809.251,20.321,0c.055.145.1.29.15.439" transform="matrix(0.875, -0.485, 0.485, 0.875, 484.506, 3777.878)" fill="#fff" fill-rule="evenodd"/>
    <path id="Path_1798" data-name="Path 1798" d="M0,10.695A10.576,10.576,0,0,0,3.4,0C5.787,1.4,6.587,3.547,7.921,5.55L.448,11.038c-.15-.11-.3-.229-.448-.344" transform="matrix(0.875, -0.485, 0.485, 0.875, 513.559, 3768.318)" fill="#fff" fill-rule="evenodd"/>
    <g id="Group_449" data-name="Group 449" transform="matrix(0.875, -0.485, 0.485, 0.875, 469.844, 3770.538)">
      <path id="Path_908" data-name="Path 908" d="M6.717,8.57c-.16.356-.367.821-.57,1.281-.379-.217-.911-.333-1.118-.662Q2.494,5.219.078,1.173C-.073.91.011.2.2.106A1.216,1.216,0,0,1,1.351.186,12.464,12.464,0,0,1,3.116,2.411C4.3,4.343,5.4,6.321,6.717,8.57" transform="translate(10.105 2.877)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_909" data-name="Path 909" d="M.138,2.006A3.651,3.651,0,0,1,.15,1.178,10.92,10.92,0,0,1,.57,0c.356.338.958.633,1.039,1.027C2.142,3.759,2.6,6.511,3,9.264c.052.359-.352.785-.545,1.178C2,10.08,1.248,9.779,1.164,9.35.688,6.926.37,4.471,0,2.028c.046-.009.1-.015.138-.021" transform="translate(23.782)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_910" data-name="Path 910" d="M.648,9.651C.451,7.536.234,5.415.062,3.285a9.515,9.515,0,0,1,0-2.177A1.469,1.469,0,0,1,.758.067c.7-.244,1.123.2,1.175.917.13,1.7.225,3.4.359,5.1a14.283,14.283,0,0,0,.231,1.493c.3,1.557-.084,2.02-1.875,2.075" transform="translate(32.875 0.918)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_918" data-name="Path 918" d="M19.827.241A17.938,17.938,0,0,1,30.6,1.96c4.462,2.093,8.479,4.864,10.924,9.385a2.516,2.516,0,0,1-.516,3.311,20.524,20.524,0,0,1-9.347,6.119c-1.794.541-3.716.672-5.484,1.264-3.132,1.048-5.906-.522-8.775-1.073C13.585,20.239,9.838,19.078,6.09,18a9.087,9.087,0,0,1-2.277-1.392c-1.108-.738-2.234-1.458-3.271-2.291A1.629,1.629,0,0,1,.015,13c1.042-5.068,4.4-8.26,8.873-10.329A22.472,22.472,0,0,1,19.827.241m2.743,1.913c-.047-.148-.095-.293-.148-.439-2.513.251-5.048.374-7.536.785A15.95,15.95,0,0,0,2.606,11.225c-.822,1.6-.7,2,.793,2.944a18.827,18.827,0,0,0,3.825,2.142A70.136,70.136,0,0,0,17.258,19.29c3.533.648,7.145,1.71,10.821.549a12.936,12.936,0,0,1-2.735-.384c-1.583-.577-3.421-1.011-4.557-2.124A8.1,8.1,0,0,1,18.3,10.047c.266-1.606.189-3.29,1.423-4.612.99-1.057,1.909-2.185,2.851-3.282m9.574,15.98c.144.114.3.234.448.344l7.473-5.488c-1.334-2-2.135-4.155-4.521-5.55a10.576,10.576,0,0,1-3.4,10.695" transform="translate(7.166 11.812)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_919" data-name="Path 919" d="M6.864,10.213C4.587,7.322,2.307,4.433,0,1.5.185,1.219.48.772,1,0A22.4,22.4,0,0,1,3.594,2.48C5.038,4.37,6.381,6.35,7.652,8.36c.24.38-.043,1.1-.084,1.652-.235.072-.471.138-.7.2" transform="translate(0 7.804)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_920" data-name="Path 920" d="M11.27.523c-.362.414-.645.963-1.1,1.207Q5.822,4.086,1.381,6.3C1.021,6.476.466,6.274,0,6.242.212,5.71.272,4.964.663,4.68A28.49,28.49,0,0,1,4.1,2.671,42,42,0,0,1,8.126.643,17.053,17.053,0,0,1,10.994,0c.093.174.185.348.277.523" transform="translate(45.529 13.078)" fill="#101820" fill-rule="evenodd"/>
      <path id="Path_921" data-name="Path 921" d="M6.127,0c.986.391,1.262,1.106.669,2.132S5.635,4.2,5.008,5.217C4.241,6.456,3.422,7.669,2.632,8.9c-.1.153-.125.4-.257.483C1.749,9.753,1.489,11.13.484,10.4-.627,9.591.462,8.936.907,8.242,2.646,5.544,4.345,2.821,6.127,0" transform="translate(39.361 5.702)" fill="#101820" fill-rule="evenodd"/>
    </g>
  </g>
</svg>

            <img :src="slide.url" alt="">
            <portal to="modal">
    <transition name="burger-fade">
      <div class="full-size-pic" v-if="modalActive === index">
         <div class="overlay-pic" @click="modalActive = null"></div>
          <img :src="slide.url" alt="">

      </div>
     

    </transition>
    </portal>
        </div>
    </swiper-slide>
    
    
  </swiper>
  <div class="navig-history-slider">
      <div class="inner-wrapper">
         
      <div class="history-slider-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="34.581" height="25.07" viewBox="0 0 34.581 25.07">
  <g id="Group_1491" data-name="Group 1491" transform="translate(0.534 0.535)">
    <g id="menu" transform="translate(0 0)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M15.535,1.507a63.818,63.818,0,0,0,8.107,5.662c.783.464,1.585.908,2.411,1.294-1.195.049-2.415,0-3.622-.049-1.282-.053-2.55-.1-3.76-.043-5.225.282-10.4,1.241-15.642,1.142-1.8-.03-4.764,2.672-1.708,2.729,5.945.11,11.775-1.069,17.7-1.2.983-.018,1.987,0,3,.028a32.561,32.561,0,0,0,6.7-.319c-2.928,3.079-6.282,5.748-8.8,9.2-.758,1.035-.156,2.737.88,1.314,3.037-4.168,7.3-7.2,10.557-11.179a1.71,1.71,0,0,0,.271-.464,1.362,1.362,0,0,0,.429-1.042c0-.046,0-.089,0-.129-.026-.784-1.146-.945-2.265-.685a15.461,15.461,0,0,1-5.849-2.683A71.758,71.758,0,0,1,17.267.326,1.536,1.536,0,0,0,16.287,0C15.372,0,14.539.685,15.535,1.507Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 31.986, 24)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

      </div>
          <div class="history-slider-next">
<svg xmlns="http://www.w3.org/2000/svg" width="34.581" height="25.07" viewBox="0 0 34.581 25.07">
  <g id="Group_1490" data-name="Group 1490" transform="translate(25.293 -3.205)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

             </div>
      </div>
   
  </div>
  </div>
</template>

<script>
import Hammer from '././../helpers/hammer';
export default {
  props: ['hasTitle', 'slideData'],
  data() {
        let that = this;
      return {
          swipeRight: null,
          swipeLeft: null,
          modalActive: null,
          slides: [
              {
                  img: 'slide1.jpg'
          },
    
          {
 img: 'slide2.jpg'
          },
          {
 img: 'slide3.jpg'
          },
          {
 img: 'slide4.jpg'
          },
          {
 img: 'slide5.jpg'
          },
   
          
          ],
        swiperOptions: {
            slidesPerView: "auto",
            spaceBetween: 30,
            speed: 1000,
            grabCursor: true,
            freeMode: true,
                navigation: {
    nextEl: '.history-slider-next',
    prevEl: '.history-slider-prev',
    disabledClass: 'history-slider-disabled'
  },
  breakpoints: {
    0:{
      spaceBetween: 15,
    },
     1024:{
      spaceBetween: 30,
    } 
  },
            

            on: {
               touchMove(){
                    document.querySelectorAll(".swiper-slide").forEach(swiperslide => {
                        if(that.swiper.touches.diff > 0){
                            swiperslide.style.transform = "rotate(-3deg) scale(0.9)"
                        }

                         if(that.swiper.touches.diff < 0){
                            swiperslide.style.transform = "rotate(3deg) scale(0.9)"
                        }
                        
                    })
                    //console.log(that.swiper.touches.diff)
                },
                touchEnd(){
                       document.querySelectorAll(".swiper-slide").forEach(swiperslide => {
                        swiperslide.style.transform = "rotate(0) scale(1)"
                    })
                },
            },
          
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    methods: {
        // initHammer(){
        //   console.log("hammer initialized")
        //    let that = this;
        //     let el = document.querySelector(".history-slider .swiper-wrapper");
        //     let hammertime = new Hammer(el);
        //     hammertime.on('panstart', function(ev) {
        //      if(ev.pointerType !== "mouse"){
        //         that.stopScrolling();
        //         console.log(ev)
        //      }
        //     });
        //     hammertime.on('panmove', function(ev) {
        //     if(ev.pointerType !== "mouse"){
        //     that.stopScrolling();
        //     console.log(ev)
        //     }
        //     });
        // },

        // stopScrolling(){
        //     this.$store.commit('main/galleryTouchToggler', this.$store.state.main.galleryTouch = true)
            
            
        // },
        //     startScrolling(e){
        //        e.preventDefault();
        //        e.stopPropagation();
             
        //         if( e.target == document.querySelector(".history-slider .swiper-wrapper") ||  e.target.parentElement.parentElement == document.querySelector(".history-slider .swiper-wrapper")){

        //             this.$store.commit('main/galleryTouchToggler', this.$store.state.main.galleryTouch = true);

        //         } else {
        //             this.$store.commit('main/galleryTouchToggler', this.$store.state.main.galleryTouch = false);
        //         }
            
          
          
        // },
      showFull(id){
        if(window.innerWidth >= 1024){

             if(this.modalActive === id){
          this.ModalActive = null;
        } else {
          this.modalActive = id;
        }
        


        }
     
      }
    },
    created(){
      // window.addEventListener("touchmove", this.startScrolling, {passive: false});
    },
    mounted() {
    this.$nextTick(() => {
      // if(document.querySelector(".history-slider")){
      //   this.initHammer();
      // }
        
    })
    }
}
</script>

<style>

</style>